const getPagesArray = (totalPages) => {
  const total = [];
  if (totalPages > 1) {
    for (let i = 2; i < totalPages; i++) {
      total.push(i);
    }
  }
  return total;
};

export default getPagesArray;
